module.exports = __webpack_public_path__ + "static/media/plus.aa8234e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Dashboard/components/SquareButton/assets/plus.svg
// module id = 1339
// module chunks = 0